module.exports = __webpack_public_path__ + "static/media/home.a779c69c.svg";